import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { theme } from './theme';

// N7: deutsche Kalender-Locale (Wochenstart Montag, Monats-/Tagesnamen) für die
// @mantine/dates-Picker. Anzeige bleibt TT.MM.JJJJ (valueFormat je Feld).
dayjs.locale('de');
import { router } from './router';
import { createQueryClient } from './lib/queryClient';
import { redirectToLogin } from './lib/session';
import { notify } from './lib/notify';
import { NotificationHost } from './components/NotificationHost';

// A2-6: one QueryClient wiring up the uniform error toast and central 401
// handling. The 401 handler needs the client itself; a holder breaks the
// initialization cycle (the closure only runs at error time, after assignment).
const clientRef: { current: QueryClient | null } = { current: null };
const queryClient = createQueryClient({
  notifyError: (message) => notify.error(message),
  onUnauthorized: () => {
    if (clientRef.current) redirectToLogin(router, clientRef.current);
  },
});
clientRef.current = queryClient;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <DatesProvider settings={{ locale: 'de', firstDayOfWeek: 1 }}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
        <NotificationHost />
      </DatesProvider>
    </MantineProvider>
  </React.StrictMode>,
);
